import { AxiosError } from 'axios';

import { unhandledRequest } from 'api/request';

type SettingsResponse = {
  connected: boolean;
  baseUrl?: string;
  domainName?: string;
  templates: string[];
};

type JobResponse = {
  templateName?: string;
};

type CreatedUser = {
  results: {
    USER_EMAIL: string;
  };
  createdBy: string;
  dateSent: string;
};

export type ApplicationResponse = CreatedUser | {};

export function isCreatedUserResponse(response: ApplicationResponse): response is CreatedUser {
  return 'createdBy' in response;
}

export type CreateApplicationErrorResponse = AxiosError<{ message: string }>;

export async function adManagerGetSettings() {
  const response = await unhandledRequest.get<SettingsResponse>({
    url: '/integrations/ad-manager/settings/',
  });
  return response.data;
}

export async function adManagerSaveSettings(
  authToken: string,
  baseUrl: string,
  domainName: string
) {
  const response = await unhandledRequest.post({
    url: '/integrations/ad-manager/settings/',
    data: { authToken, baseUrl, domainName },
  });
  return response.data;
}

export async function adManagerDisconnect() {
  const response = await unhandledRequest.delete({
    url: '/integrations/ad-manager/settings/',
  });
  return response.data;
}

export async function adManagerGetTemplates() {
  const response = await unhandledRequest.get<string[]>({
    url: '/integrations/ad-manager/templates/',
  });
  return response.data;
}

export function adManagerAddTemplate(templateName: string) {
  return unhandledRequest.post({
    url: '/integrations/ad-manager/templates/',
    data: { templateName },
  });
}

export function adManagerRemoveTemplate(templateName: string) {
  return unhandledRequest.post({
    url: '/integrations/ad-manager/templates/remove/',
    data: { templateName },
  });
}

export async function adManagerGetJob(jobId: string) {
  const response = await unhandledRequest.get<JobResponse>({
    url: `/integrations/ad-manager/jobs/${jobId}/`,
  });
  return response.data;
}

export function adManagerSaveJob(templateName: string, jobId: string) {
  return unhandledRequest.post({
    url: `/integrations/ad-manager/jobs/${jobId}/`,
    data: { templateName },
  });
}

export function adManagerRemoveJob(jobId: string) {
  return unhandledRequest.delete({ url: `/integrations/ad-manager/jobs/${jobId}/` });
}

export async function adManagerGetApplication(applicationId: string) {
  const response = await unhandledRequest.get<ApplicationResponse>({
    url: `/integrations/ad-manager/applications/${applicationId}/`,
  });
  return response.data;
}

export function adManagerCreateApplication(applicationId: string) {
  return unhandledRequest.post({
    url: `/integrations/ad-manager/applications/${applicationId}/`,
  });
}

export function adManagerBulkCreateApplications(jobId: string, applicationIds: string[]) {
  return unhandledRequest.post({
    url: `/integrations/ad-manager/jobs/${jobId}/bulk-create/`,
    data: { applicationIds },
  });
}
